"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTypeOrDefault = exports.typeOf = exports.is = exports.caseOf = exports.areSame = void 0;

var Strings = _interopRequireWildcard(require("../Strings"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var typeOf = function typeOf(x) {
  if (x === null) return 'Null';
  if (Array.isArray(x)) return 'Array';
  if (x instanceof Date) return 'Date';
  return Strings.capitalize(_typeof(x));
};

exports.typeOf = typeOf;

var areSame = function areSame(first) {
  return function (second) {
    return typeOf(first) === typeOf(second);
  };
};

exports.areSame = areSame;

var caseOf = function caseOf(cases) {
  return function (toValue) {
    return function (value) {
      switch (typeOf(toValue(value))) {
        case 'Array':
          return cases.Array(value);

        case 'Boolean':
          return cases.Boolean(value);

        case 'Date':
          return cases.Date(value);

        case 'Function':
          return cases.Function(value);

        case 'Number':
          return cases.Number(value);

        case 'Null':
          return cases.Null();

        case 'Object':
          return cases.Object(value);

        case 'String':
          return cases.String(value);

        case 'Undefined':
          return cases.Undefined();

        default:
          throw new TypeError('Unexpected case of type.');
      }
    };
  };
};

exports.caseOf = caseOf;

var is = function is(type) {
  return function (value) {
    return typeOf(value) === type;
  };
};

exports.is = is;

var withTypeOrDefault = function withTypeOrDefault(expectedType) {
  return function (defaultValue) {
    return function (value) {
      return is(expectedType)(value) ? value : defaultValue;
    };
  };
};

exports.withTypeOrDefault = withTypeOrDefault;
//# sourceMappingURL=index.js.map